import { useQuery } from '@tanstack/react-query'

import { QUERY_KEY_NEW_LEADS_QUEUE_SIZE } from '@/types/constants'
import { authenticatedApi } from '@/utils/api'

async function getNewLeadsQueueSize() {
  return authenticatedApi.get(`customer/new_leads_queue_size`).json<{ size: number }>()
}

export const useNewLeadsQueueSize = (enabled = true) => {
  return useQuery({
    queryKey: [QUERY_KEY_NEW_LEADS_QUEUE_SIZE],
    queryFn: () => getNewLeadsQueueSize(),
    enabled,
  })
}
